import { HFlex, PageContent, VFlex } from "src/components";

import { useBindingData } from "./hooks/useBotBindingData";
import { useBindBot, useDeleteBotBinding } from "./hooks/useBotbindingModal";
import { useBotData } from "./hooks/useBotData";
import { useAddBot, useDeleteBot, useEditBot } from "./hooks/useBotModal";
import { BotBindingsTable } from "./botBindingsTable";
import { BotUsersTable } from "./botUsersTable";
import { ImproveBotAccuracyToggle } from "./improveBotAccuracyToggle";
import { SetupSteps } from "./setupSteps";
import { ShareBotLink } from "./shareBotLink";

import "./botManagement.scss";

/**
 * Bot Management component
 * Displays and manages bot accounts with a 4-step setup process
 */
export const BotManagement = () => {
  // Data management hooks
  const { bots, loading: botLoading, botError, refetchBots } = useBotData();
  const {
    bindings,
    loading: bindingsLoading,
    bindingError,
    refetchBindings,
    toggleBindingStatus
  } = useBindingData();

  // Modal hooks to manage bot and binding data
  const { addBotModal, openAddBotModal } = useAddBot(refetchBots);
  const { editBotModal, openEditBotModal } = useEditBot(refetchBots);
  const { deleteBotModal, openDeleteBotModal } = useDeleteBot(refetchBots);
  const { bindBotModal, openBindBotModal } = useBindBot(refetchBindings, bots);
  const { deleteBotBindingModal, openDeleteBotBindingModal } =
    useDeleteBotBinding(refetchBindings);

  return (
    <VFlex className="bot-management-container">
      <PageContent>
        <SetupSteps />
      </PageContent>
      <HFlex align="center" justify="space-between">
        <ImproveBotAccuracyToggle />
        <ShareBotLink />
      </HFlex>
      <BotUsersTable
        bots={bots}
        bindings={bindings}
        loading={botLoading}
        error={botError}
        onAddBot={openAddBotModal}
        onEditBot={openEditBotModal}
        onDeleteBot={openDeleteBotModal}
      />
      <BotBindingsTable
        bindings={bindings}
        loading={bindingsLoading}
        error={bindingError}
        onBindBot={openBindBotModal}
        onToggleBindingStatus={toggleBindingStatus}
        onDeleteBinding={openDeleteBotBindingModal}
      />
      {addBotModal}
      {editBotModal}
      {deleteBotModal}
      {bindBotModal}
      {deleteBotBindingModal}
    </VFlex>
  );
};
